import { ColDef, GridApi, ColGroupDef } from 'ag-grid-community';
import { groupBy } from 'lodash-es';

// 菜单处理函数
// 扩展参数
export type TableCmdProvider = () => GridApi;

export interface ITableCmdHandles {
  init(tableCtx: { api: TableCmdProvider }): void;
  execute(cmd: string, selectedRows?: any[]): Promise<void>;
}

// 从注解读列配置
// eslint-disable-next-line @typescript-eslint/ban-types
export function getTableAnnotations(clazz: Function) {
  const pt = clazz.prototype;
  let fields = (pt.$fields || []) as (ColDef & {
    colGroup?: string;
    colGroupClass?: string;
  })[];
  // 包含分组
  if (fields.find((e) => e.colGroup)) {
    const tmp: ColDef[] = [];

    // 处理表头分组
    let groupName: string | undefined = undefined;
    let groupCol: ColGroupDef = { children: [] };
    for (const f of fields) {
      if (f.colGroup) {
        if (f.colGroup !== groupName) {
          if (groupName) {
            tmp.push(groupCol);
          }

          groupName = f.colGroup;
          groupCol = {
            headerName: groupName,
            marryChildren: true,
            headerClass: f.colGroupClass,
            children: []
          };
        }

        delete f.colGroup;
        delete f.colGroupClass;
        groupCol.children.push(f);
      } else {
        if (groupName) {
          tmp.push(groupCol);
          groupName = undefined;
        }

        tmp.push(f);
      }
    }

    if (groupName) {
      tmp.push(groupCol);
      groupName = undefined;
    }

    fields = tmp;
  }

  // left none right 排序
  const grouped = groupBy(fields, (f) => {
    if (f.pinned === true) return 'left';
    if (!f.pinned) return 'none';
    return f.pinned;
  });

  fields = [
    ...(grouped.left || []),
    ...(grouped.none || []),
    ...(grouped.right || [])
  ];

  return {
    fields: fields as ColDef[],
    rowId: pt.$rowid as string,

    // form input参数
    inputs: pt.$inputs as string[]
  };
}
